import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    // Dikkat: buradaki url diğer uygulamalardakinden farklı:
    //baseUrl: process.env.NODE_ENV === "production" ? "../EntryPointService/api/EntryPoint" : "/api",
    baseUrl: process.env.NODE_ENV === "production" ? "./EntryPointService/api/EntryPoint" : "/api",
  }),
  tagTypes: [
    // TODO
    "Customer"
  ],
  endpoints: (builder) => ({})
})

export default api
